import { api } from "./axios";

// Email Contact Interface
export interface EmailContact {
  id: number;
  firstName: string;
  lastName: string;
  company: string;
  role: string;
  email: string;
  createdAt?: string;
  updatedAt?: string;
}

// Email Template Interface
export interface EmailTemplate {
  id: number;
  name: string;
  greetingText: string;
  closingText: string;
  isDefault: boolean;
  isSystemTemplate: boolean;
  createdAt?: string;
  updatedAt?: string;
}

// CSV Upload Response
export interface CSVUploadResponse {
  success: boolean;
  message: string;
  data: {
    addedCount: number;
    failedCount: number;
    errors: Array<{
      row: number;
      email: string;
      reason: string;
    }>;
  };
}

// Email API Repository
export const emailApi = {
  // OAuth Connection Management
  getOAuthStatus: () => api.get("/email/oauth/status"),
  initiateOAuth: () => api.get("/email/oauth/connect"),
  disconnectOAuth: () => api.delete("/email/oauth/disconnect"),



 
  // Send Email (omit scheduledFor for immediate send; ISO 8601, >=60s in the future, to schedule)
  sendEmail: (data: {
    contactIds: number[];
    templateId: number;
    pitchIds: number[];
    subject: string;
    customGreeting?: string;
    customClosing?: string;
    pitchBodyTemplateId?: string | null;
    /**
     * Per-recipient notes keyed by contact id, replacing {{personalizedMessage}} in that
     * contact's copy. Same shape the pitch submission endpoint takes; omit when the chosen
     * template has no such merge field.
     */
    contacts?: Record<string, string>;
    scheduledFor?: string;
  }) => api.post("/email/send", data),

  // Cancel a pending scheduled send (400 if not SCHEDULED, 404 if not found, 409 if already sending)
  cancelScheduledSend: (emailLogIds: string[]) =>
    api.delete("/email/scheduled", { data: { emailLogIds } }),

};
